import React, { useEffect, useState } from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material'
import { cn, inputValidation } from 'src/lib/utils'
import ContentCircle from 'src/Common/ui/contentCircle'
import '../../../Styles/Tasktable.css'
import SelectInput from 'src/Common/ui/selectInput'
import Textarea from 'src/Common/ui/textArea'
import AddSquareIcon from 'src/Common/Icon/AddSquareIcon'
import DatePickerInput from 'src/Common/ui/DatePickerInput'

export default function Tasktable ({ data, departments, taskInputChange, handleAddTask, handleDeleteTask, taskSelectChange, errors, control }) {
    const [ taskList, setTasklist ] = useState([])
    useEffect(() => {
        if (data?.length > 0) {
            setTasklist(data)
        }
    }, [data])
    return (
        <>
            <div className='h-[100%]'>
                <div className=''>
                    <div>
                        <TableContainer className={cn('task-table')} style={{ maxHeight: 500 }}>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow className='!bg-none'>
                                        <TableCell sx={{ fontWeight: 600, fontSize: '17px' }} align='center'>{'S.No'}</TableCell>
                                        <TableCell align='center' className='font-semibold !px-0' sx={{ fontWeight: 600, fontSize: '17px' }}>
                                            <p className={cn('task-table-th pl-3', 'flex flex-col flex-grow justify-center pl-3')}>
                                                {'Task'}
                                            </p>
                                        </TableCell>
                                        <TableCell align='center' className='font-semibold !px-0' sx={{ fontWeight: 600, fontSize: '17px' }}>
                                            <p className={cn('task-table-th pl-3', 'flex flex-col flex-grow justify-center pl-3')}>
                                                {'Start Date'}
                                            </p>
                                        </TableCell>
                                        <TableCell align='center' className='font-semibold !px-0' sx={{ fontWeight: 600, fontSize: '17px' }}>
                                            <p className={cn('task-table-th pl-3', 'flex flex-col flex-grow justify-center pl-3')}>
                                                {'End Date'}
                                            </p>
                                        </TableCell>
                                        <TableCell align='center' className='font-semibold !px-0' sx={{ fontWeight: 600, fontSize: '17px' }}>
                                            <p className={cn('task-table-th pl-3', 'flex flex-col flex-grow justify-center pl-3')}>
                                                {'Department'}
                                            </p>
                                        </TableCell>
                                        <TableCell align='center' className='font-semibold !px-0' sx={{ fontWeight: 600, fontSize: '17px' }}>
                                            <p className={cn('task-table-th pl-3', 'flex flex-col flex-grow justify-center pl-3')}>
                                                {'Responsible'}
                                            </p>
                                        </TableCell>
                                        <TableCell align='center' className='font-semibold !px-0' sx={{ fontWeight: 600, fontSize: '17px' }}>
                                            <p className={cn('task-table-th pl-3', 'flex flex-col flex-grow justify-center pl-3')}>
                                                {'Action'}
                                            </p>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {taskList?.map((item, j) => {
                                        return (item?.actions !== 11 && <>
                                            <TableRow sx={{ height: '30px' }}>
                                                <TableCell align='center' >
                                                    <div className='w-full flex justify-center'>
                                                        <ContentCircle className={'min-h-6 text-center bg-[hsl(var(--primary-table-head))] min-w-6'} contentClassName={'text-primary'} content={j + 1} />
                                                    </div>
                                                </TableCell>
                                                <TableCell sx={{ height: '100%' }} >
                                                    <p className={cn('task-table-td', 'flex flex-col flex-grow justify-center pl-3')}>
                                                        <Textarea
                                                            errors={errors}
                                                            control={control}
                                                            required
                                                            rules={{
                                                                validate: (value) => {
                                                                    return inputValidation(value, value?.length < 251, 'This field is required', 'Characters should be less than 250')
                                                                }
                                                            }}
                                                            name={`binaryQuestions-question-${j}`}
                                                            placeholder="Enter Task"
                                                            type="text"
                                                            onValueChange={(e) => taskInputChange(e, j, 'name')}
                                                            value={item.name}
                                                            defaultValue={item.name}
                                                            className='!border-none !ring-0 !shadow-none !h-auto min-h-2 !max-h-14 !p-0'
                                                            maxLength={250}
                                                        />
                                                    </p>
                                                </TableCell>
                                                <TableCell sx={{ height: '100%' }} >
                                                    <p className={cn('task-table-td', 'flex flex-col flex-grow justify-center pl-3')}>
                                                        <DatePickerInput
                                                            errors={errors}
                                                            control={control}
                                                            // minDate={item?.startDate || ''}
                                                            // maxDate={fromMaxDate}
                                                            required
                                                            name="selectedDate"
                                                            value={item?.startDate}
                                                            defaultValue={item?.startDate}
                                                            onValueChange={(e) => {
                                                                taskSelectChange(e, j, 'startDate')
                                                            }}
                                                        />
                                                    </p>
                                                </TableCell>
                                                <TableCell sx={{ height: '100%' }} >
                                                    <p className={cn('task-table-td', 'flex flex-col flex-grow justify-center pl-3')}>
                                                        {/* <DateInput
                                                            required
                                                            name="selectedDate"
                                                            iconColor={'hsl(var(--primary))'}
                                                            iconClassName={'!h-4 !w-4'}
                                                            className={'!border-none !shadow-none !bg-card'}
                                                            value={item?.endDate}
                                                            defaultValue={item?.endDate}
                                                            onValueChange={(e) => {
                                                                taskSelectChange(e, j, 'endDate')
                                                            }}
                                                        /> */}
                                                        <DatePickerInput
                                                            errors={errors}
                                                            control={control}
                                                            minDate={item?.startDate || ''}
                                                            // maxDate={fromMaxDate}
                                                            required
                                                            name="selectedDate"
                                                            value={item?.endDate}
                                                            defaultValue={item?.endDate}
                                                            onValueChange={(e) => {
                                                                taskSelectChange(e, j, 'endDate')
                                                            }}
                                                        />
                                                    </p>
                                                </TableCell>
                                                <TableCell sx={{ height: '100%' }} >
                                                    <p className={cn('task-table-td', 'flex flex-col flex-grow justify-center pl-3')}>
                                                        <SelectInput
                                                            control={control}
                                                            errors={errors}
                                                            name="category"
                                                            placeholder="Select"
                                                            onValueChange={(value) => taskSelectChange(value, j, 'departmentId')}
                                                            value={item?.departmentId}
                                                            defaultValue={item?.departmentId}
                                                            options={departments?.map((data) => ({ id: data?.id, value: data?.id, label: data?.name, status: data?.status }))}
                                                            className={'!border-none !shadow-none !ring-0 !bg-card '}

                                                        />
                                                    </p>
                                                </TableCell>
                                                <TableCell sx={{ height: '100%' }} >
                                                    <p className={cn('task-table-td', 'flex flex-col flex-grow justify-center pl-3')}>
                                                        <Textarea
                                                            errors={errors}
                                                            control={control}
                                                            required
                                                            rules={{
                                                                validate: (value) => {
                                                                    return inputValidation(value, value?.length < 251, 'This field is required', 'Characters should be less than 250')
                                                                }
                                                            }}
                                                            name={'binaryQuestions-questio'}
                                                            placeholder="Enter Responsible"
                                                            type="text"
                                                            onValueChange={(e) => taskInputChange(e, j, 'responsible')}
                                                            value={item?.responsible}
                                                            defaultValue={item?.responsible}
                                                            className='!border-none !ring-0 !shadow-none !h-7 !max-h-14 !p-0'
                                                            maxLength={250}
                                                        />
                                                    </p>
                                                </TableCell>
                                                { <TableCell >
                                                    <p onClick={() => { handleDeleteTask(j) }} className={cn('task-table-td', 'flex flex-col flex-grow justify-center pl-3')}>
                                                        <Tooltip title="Delete Task" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                            <div className='flex justify-center cursor-pointer'><img src='/Common/Icon/DeleteIconGov.svg' className='w-[25px] h-[25px]' /></div>
                                                        </Tooltip>
                                                    </p>
                                                </TableCell>}
                                            </TableRow>
                                        </>)
                                    })
                                    }

                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                    <div className='w-full flex justify-end mt-5 pr-1 cursor-pointer'>
                        <div className='flex gap-2 items-center text-primary' onClick={() => { handleAddTask() } }><AddSquareIcon /> <span>New</span></div>
                    </div>
                </div>
                {/* {!viewCondition() && <div className='w-full flex justify-end mt-5 pr-1 cursor-pointer'>
                        <div className='flex gap-2 items-center text-primary' onClick={() => { handleAddControls('binaryQuestions') } }><AddSquareIcon /> <span>New</span></div>
                    </div>} */}
                {/* {data.length > 0 && <div className="flex items-center justify-between mt-2 p-4 h-[10%]">
                        <Typography className="text-muted">
                                Showing data {currentPage} to {rowsPerPage} of {totalPages} entries
                        </Typography>
                        <Pagination
                            sx={{ marginLeft: 'auto' }}
                            count={totalPages}
                            page={currentPage}
                            onChange={handlePageChange}
                            variant="outlined"
                            shape="rounded" />
                    </div>} */}
            </div>
        </>
    )
}
